import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Flex, media } from 'lib/style-utils';
import { Link } from 'react-router-dom';

const Wrapper = styled.div`
  width: 100%;
  height: auto;
`;

const column = Flex.extend`
  flex-direction: column;
  width: 50%;
  height: 500px;
  text-align: center;
  color: #333333;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: all .5s;

  .mobile.hidden {
    display: block;
  }
  .mobile.show {
    display: none;
  }

  ${media.tablet`
    width: 100%;
  `}
  ${media.mobile`
    height: 390px;

    .mobile.hidden {
      display: none;
    }
    .mobile.show {
      display: block;
    }
  `}
`;

/** Left Column */
const Left = column.extend`
  float: left;
  background-image: url('/images/home/contact-us.jpg');
  background-position: left;
`;

/** Right Column */
const Right = column.extend`
  background-image: url('/images/home/shoplist.jpg');
`;

const Btn = styled.button`
  width: 160px;
  height: 45px;
  background: #fff;
  color: #aaaaaa;
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: 23px;
  font-family: Lato;
  text-align: center;
  margin: 30px auto 0;
  font-size: 14px;
  letter-spacing: 0.7px;
  cursor: pointer;

  &:hover {
    background: #f9f9f9;
  }

  &:active {
    background: #f2f2f2;
  }

  ${media.mobile`
    width: 154px;
    font-size: 13px;
  `}
`;

const Title = styled.p`
  font-size: 22px;
  margin-bottom: 59px;
  font-weight: 700;
  letter-spacing: 2.2px;
  color: #333333;

  ${media.mobile`
    font-size: 18px;
    letter-spacing: 1.8px;
  `}
`;

const SecondTitle = styled.p`
  margin-bottom: 18px;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.4px;
  color: #333333;

  ${media.mobile`
    font-size: 16px;
  `}
`;

const Desc = styled.p`
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 16px;
  line-height: 1.9;
  letter-spacing: 0.4px;
  color: #333333;

  ${media.mobile`
    font-size: 14px;
    letter-spacing: 0.3px;
  `}
`;

const handleScrollTop = (e) => {
  window.scrollTo(0,0);
}

class Bottom extends PureComponent {
  render() {
    return (
      <Wrapper>
        <Left>
          <Title>CONTACT US</Title>
          <SecondTitle>WHOLESALE</SecondTitle>

          <div className="mobile hidden">
            <Desc>아이들의 숙면을 도와주는 브랜드 베이비디디에 대한</Desc>
            <Desc>도매, 협업, 협찬 문의는 아래 링크를 통해 보내주세요.</Desc>
          </div>

          <div className="mobile show">
            <Desc>아이들의 숙면을 도와주는 브랜드</Desc>
            <Desc>베이비디디에 대한</Desc>
            <Desc>도매, 협업, 협찬 문의는 아래 링크를 통해 보내주세요.</Desc>
          </div>

          <Link to="/contact" onClick={handleScrollTop}><Btn>CONTACT US</Btn></Link>
        </Left>

        <Right>
          <Title>SHOP LIST</Title>
          {/* <SecondTitle>샵 리스트 들어올 곳</SecondTitle> */}

          <div className="mobile hidden">
            <Desc>GBH를 다양한 경로로 만나보세요.</Desc>
          </div>

          <div className="mobile show">
            <Desc>GBH를 다양한 경로로 만나보세요.</Desc>
          </div>
          <Link to="/shoplist" onClick={handleScrollTop}><Btn>SHOP LIST</Btn></Link>
        </Right>
      </Wrapper>
    );
  }
}

export default Bottom;



// WEBPACK FOOTER //
// ./src/components/Home/Bottom.js